import { Spritesheet } from 'pixi.js';
import { DirectionEnum } from '../types/enums';
import { IPosition } from '../types/types';

export const getDirection = ({ x, y }: IPosition) => {
  switch (`${x + 1}${y + 1}`) {
    case '21':
      return DirectionEnum['RIGHT'];
    case '22':
      return DirectionEnum['TOP-RIGHT'];
    case '20':
      return DirectionEnum['BOTTOM-RIGHT'];
    case '10':
      return DirectionEnum['BOTTOM'];
    case '00':
      return DirectionEnum['BOTTOM-LEFT'];
    case '01':
      return DirectionEnum['LEFT'];
    case '02':
      return DirectionEnum['TOP-LEFT'];
    case '12':
      return DirectionEnum['TOP'];
    default:
      return DirectionEnum['RIGHT'];
  }
};

export const isValidSpritesheet = (
  spritesheet: Spritesheet | undefined | null,
): boolean => {
  return !!(
    spritesheet &&
    spritesheet.baseTexture &&
    spritesheet.baseTexture.valid
  );
};

/**
 * Sprites only exist for left-facing directions (bottom, bottom-left, left,
 * top-left, top). Right directions map to their left equivalents (the flip
 * is handled elsewhere).
 */
export const getSpriteDirectionName = (
  direction: DirectionEnum | undefined,
): string => {
  if (direction === undefined) {
    return 'bottom';
  }

  switch (direction) {
    case DirectionEnum.BOTTOM:
      return 'bottom';
    case DirectionEnum['BOTTOM-LEFT']:
      return 'bottom-left';
    case DirectionEnum.LEFT:
      return 'left';
    case DirectionEnum['TOP-LEFT']:
      return 'top-left';
    case DirectionEnum.TOP:
      return 'top';
    case DirectionEnum['BOTTOM-RIGHT']:
      return 'bottom-left';
    case DirectionEnum.RIGHT:
      return 'left';
    case DirectionEnum['TOP-RIGHT']:
      return 'top-left';
    default:
      return 'bottom';
  }
};

export const lerp = (start: number, end: number, t: number): number =>
  start + (end - start) * t;
